export const catalogo = {
  cursos: { title: 'Catalog · Courses', description: 'Courses available to you.' },
  trilhas: { title: 'Catalog · Tracks', description: 'Available learning tracks.' },
  tabs: { cursos: 'Courses', trilhas: 'Tracks' },
  card: {
    matriculado: 'Enrolled',
    matricular: 'Enroll',
    continuar: 'Continue',
    verDetalhes: 'View details',
    comCertificado: 'Issues certificate',
  },
  empty: {
    cursos: 'No courses available at the moment.',
    cursosDesc: 'As soon as new courses are published, they show up here.',
    trilhas: 'No tracks available at the moment.',
    trilhasDesc: 'As soon as new tracks are published, they show up here.',
  },
  matricula: {
    sucessoCurso: 'You have enrolled in the course.',
    sucessoTrilha: 'You have enrolled in the track.',
    prereqTitle: 'You haven’t completed yet:',
    prereqHint: 'You can proceed anyway.',
    erroAtivaExistente: 'You are already enrolled.',
    erroArquivado: 'This content has been archived and no longer accepts new enrollments.',
    erroNaoMatriculavel: 'Content unavailable.',
  },
  detalhe: {
    objetivo: 'Objective',
    tipoCurso: 'Course',
    tipoTrilha: 'Track',
    modulosCount_one: '{{count}} module',
    modulosCount_other: '{{count}} modules',
    cursosCount_one: '{{count}} course',
    cursosCount_other: '{{count}} courses',
    aulasCount_one: '{{count}} lesson',
    aulasCount_other: '{{count}} lessons',
    modulos: 'Modules',
    cursosDaTrilha: 'Courses in the track',
    aulas: 'lessons',
    progresso: 'Progress',
    concluido: 'Completed',
    iniciar: 'Start',
    continuar: 'Continue',
    matricularPara: 'Enroll to access the content.',
    opcional: 'Optional',
    quizLabel: 'Quiz',
    videoLabel: 'Video',
    textoLabel: 'Reading',
    semConteudo: 'No content available yet.',
  },
  emBreve: {
    selo: 'Coming soon',
    dica: 'Available soon',
    titulo: 'This lesson is coming soon',
    descricao: 'As soon as it is released, it shows up open in the course content.',
    voltarAoCurso: 'Back to course',
    irAoCatalogo: 'Go to catalog',
  },
  player: {
    marcarConcluida: 'Mark as completed',
    concluida: 'Lesson completed',
    concluidaTitulo: 'Lesson completed!',
    concluidaSubtitulo: 'Nice work. Keep going where you left off.',
    proximaAula: 'Next lesson',
    voltarAoCurso: 'Back to course',
    videoIndisponivel: 'Video unavailable.',
    video: {
      rotulo: 'Lesson video: {{titulo}}',
      legendaPt: 'Portuguese (Brazil)',
      falhou: 'The video could not be loaded.',
      tentarDeNovo: 'Try again',
    },
    posicao: 'Lesson {{atual}} of {{total}}',
    conteudoDoCurso: 'Course content',
    aulaAnterior: 'Previous lesson',
    navegacaoAulas: 'Lesson navigation',
    aulaAnteriorLabel: 'Previous lesson: {{titulo}}',
    proximaAulaLabel: 'Next lesson: {{titulo}}',
    quiz: {
      titulo: 'Quiz',
      intro: 'Answer the questions to complete this lesson.',
      iniciar: 'Start quiz',
      retomar: 'Resume attempt',
      restantes_one: '{{count}} attempt remaining',
      restantes_other: '{{count}} attempts remaining',
      ilimitado: 'Unlimited attempts',
      notaMinima: 'Passing score: {{score}}%',
      questaoDe: 'Question {{atual}} of {{total}}',
      respondidasDe: '{{atual}} of {{total}} answered',
      irPendente: 'Go to unanswered question',
      ultimaTentativa: 'Last attempt',
      verdadeiro: 'True',
      falso: 'False',
      enviar: 'Submit answers',
      enviando: 'Submitting...',
      anterior: 'Previous',
      proxima: 'Next',
      resultadoTitulo: 'Result',
      aprovado: 'Passed!',
      reprovado: 'You didn’t reach the passing score',
      suaNota: 'Your score: {{score}}%',
      refazer: 'Retake quiz',
      gabarito: 'Answer key',
      suaResposta: 'Your answer',
      respostaCorreta: 'Correct answer',
      semResposta: 'No answer',
      tentativasEsgotadas: 'You have used all attempts. Ask the instructor to reopen it.',
      notaRepresentativa: 'Your score: {{score}}%',
    },
  },
  inicio: {
    saudacao: {
      manha: 'Good morning, {{nome}}',
      tarde: 'Good afternoon, {{nome}}',
      noite: 'Good evening, {{nome}}',
    },
    subtitulo: {
      ativos_one: 'You have {{count}} course in progress.',
      ativos_other: 'You have {{count}} courses in progress.',
      tudoEmDia: 'You’re all caught up. Ready to learn something new?',
      boasVindas: 'Let’s start your learning journey.',
    },
    spotlight: {
      overline: 'Keep learning',
      proximaLabel: 'Next lesson:',
    },
    stats: {
      emAndamento: 'In progress',
      concluidos: 'Completed',
      certificados: 'Certificates',
    },
    listaTitulo: 'Your learning',
    explore: {
      titulo: 'Ready to learn something new?',
      descricao: 'Browse the catalog and find your next course or track.',
      cta: 'Browse catalog',
    },
    welcome: {
      titulo: 'Welcome to NT Academy, {{nome}}!',
      descricao: 'This is your space to grow. Start by picking a course or track in the catalog.',
      cta: 'Browse catalog',
    },
  },
  progresso: {
    continuar: 'Continue',
    revisar: 'Review',
    atribuidoPor: 'Assigned by {{nome}}',
    prazo: 'Due: {{data}}',
    proximaAula: 'Next lesson: {{titulo}}',
    cancelar: 'Cancel enrollment',
    cancelarTitle: 'Cancel this enrollment?',
    cancelarDescription: 'Your progress in this self-made enrollment will be removed.',
    cancelado: 'Enrollment canceled.',
    concluido: 'Completed',
    concluidoEm: 'Completed on {{data}}',
    maisOpcoes: 'More options',
  },
} as const;
